import ShopInvoiceAddressModelBase from '../_generated/modelBases/shop-invoice-address-model-base';

export default class ShopInvoiceAddressModel extends ShopInvoiceAddressModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
